export default "/institutions/discover.svg";